import React, { useEffect } from 'react';
import type { PlanIframeProps } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater';
import 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater';
export const DefaultBuyNowPayLaterIframe = ({ onLoaded }: PlanIframeProps) => {
  useEffect(() => {
    onLoaded(true);
  }, []);
  return null;
};
